import React from 'react'
import { Reply, ReplyWrapper } from './ElementsStyled'
import { BETREPLY_ELEMENTS_PROPS } from './interface'

export default function BetInfo({
  content,
  size,
  infoBoxBackgroundColor,
}: BETREPLY_ELEMENTS_PROPS) {
  return (
    <ReplyWrapper infoBoxBackgroundColor={infoBoxBackgroundColor}>
      {content.map((item: any, id: number) => (
        <Reply key={id} size={size}>
          <h3>{item.title}</h3>
          <p>{item.content}</p>
        </Reply>
      ))}
    </ReplyWrapper>
  )
}
